import React from "react";
import { LinkButton } from "../../misc/LinkButton/LinkButton";
import "./BannerPrimary.scss";

interface Props {

  /**
   * Heading text
   */
  heading: string;

  /**
   * Description text
   */
  description: string;

  /**
   * Link
   */
  label: string;
  to: string;
}

/**
 * Primary banner that most commonly sits at the top of a page directly under the main navigation header. Is used as a bit of a blunt instrument for important prominent messaging; eg, Covid-19.
 * 
 * @status development
 */
export const BannerPrimary: React.FC<Props> = ({ heading, description, label, to }) => {

  return (
    <div className="banner-primary">

      <div className="banner-primary__inner">

        <h4 className="banner-primary__heading">{heading}</h4>

        <div className="banner-primary__description-wrapper">

          <p className="banner-primary__description">{description}</p>
          <LinkButton
            buttonClass="secondary-button"
            className=""
            iconAlign="left"
            target="_blank"
            to={to}
          >
            {label}
          </LinkButton>

        </div>

      </div>

    </div>
  );
};
